
// vue // vuex
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from 'vuex-class';


// components
import EventSearchModel from "@/types/eventSearch/EventSearchModel";
import vSelect from "vue-select";
import EventFilter from './EventFilter.vue';

// Types
import { EventSearchState, AlarmType, DeviceType } from '@/store/event-search/types';


// Vuex modules
const EventSearchStore = namespace("eventSearch");

@Component({
    components: {
        "event-filter": EventFilter,
        "v-select": vSelect,
    }
})
export default class AlarmTypeFilter extends Vue {
    @Prop({ default: null, type: Object, required: true }) value: EventSearchModel;

    @EventSearchStore.Action loadAlarmTypes!: (serverTypeId: number) => Promise<void>;

    @EventSearchStore.State((s: EventSearchState) => s.AlarmTypes) alarmTypes!: AlarmType[];

    @EventSearchStore.State((s: EventSearchState) => s.DeviceTypes) deviceTypes!: DeviceType[];

    /**
     * @summary Lifecycle hook
     * - attempts to fetch alarm types if deviceType is set.
     */
    private async mounted(): Promise<void> {
        await this.fetchAlarmTypes();
    }

    /**
     * @summary Watcher which attempts to fetch alarmTypes
     * when a deviceType changes.
     */
    @Watch("value.deviceType")
    private async fetchAlarmTypes(): Promise<void> {
        if (this.value.deviceType) {
            await this.loadAlarmTypes(this.value.deviceType).catch((err) => {
                this.$notify({
                    type: "error",
                    title: "Failed to fetch alarm types",
                    text: err?.message ? err.message : err
                });
            });
        }
    }

    /**
     * @summary computed property to get the desired alarm type by id
     */
	public get alarmType() {
		return this.value.alarmType
			? this.alarmTypes.find((alarmType) => alarmType.eventNum === this.value.alarmType)
			: null;
	}

    /**
     * @summary computed setter to set the alarm type
     */
	public set alarmType(value) {
		this.$set(this.value, "alarmType", value ? value.eventNum : null);
	}

    /**
     * @summary computed property to get the deviceType by by id.
     */
	public get deviceType() {
		return this.value.deviceType
			? this.deviceTypes.find((deviceType) => deviceType.serverTypeID === this.value.deviceType)
			: null;
	}

    /**
     * @summary computed setter which sets the deviceType.
     */
	public set deviceType(value) {
		this.$set(this.value, "deviceType", value ? value.serverTypeID : null);
	}
}
